// src/services/adminUploadService.js
import { getToken } from '../utils/secureStorage';


const getUploadBase = () => {
  // در Production و APK اول باید env چک شود
  const envUrl = process.env.REACT_APP_FILE_API_URL;
  if (envUrl) return envUrl;

  const hostname = window.location.hostname;
  const isLocal =
    hostname === "localhost" || hostname === "127.0.0.1" ||
    /^192\.168\./.test(hostname) || /^10\./.test(hostname) ||
    /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname);

  if (isLocal) return `http://${hostname}:3002`;
  
  return "";
};

export const adminUploadService = {
  async uploadPdf({ file, coverFile, category, grade, field, subject, bookId }) {
    const formData = new FormData();
    formData.append('file', file);
    if (coverFile) formData.append('cover', coverFile);
    formData.append('category', category);
    formData.append('grade', grade);
    formData.append('subject', subject);
    if (field) formData.append('field', field);
    if (bookId) formData.append('bookId', bookId);

    const base = getUploadBase();
    
    try {
      const token = getToken(); // ✅ خواندن توکن
      const res = await fetch(`${base}/api/admin/upload-book-pdf`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}` // ✅ ارسال توکن
        },
        body: formData,
      });

      // 🆕 خواندن متن خام قبل از تبدیل به JSON برای جلوگیری از خطای Unexpected token
      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("سرور پاسخ JSON نداد. پاسخ دریافتی:", text);
        throw new Error("سرور آپلود پاسخ معتبری نداد. لطفاً مطمئن شوید پنجره Upload Server (پورت 3002) را بسته و دوباره برنامه را اجرا کرده‌اید.");
      }

      if (!res.ok) throw new Error(data.error || 'خطا در آپلود فایل');
      return data;
    } catch (e) {
      if (e.message.includes('Failed to fetch')) {
        throw new Error("ارتباط با سرور آپلود برقرار نشد. مطمئن شوید سرور (پورت 3002) روشن است.");
      }
      throw e;
    }
  },

  // 🆕 تابع حذف فیزیکی فایل از روی سرور
  async deletePhysicalFiles({ fileUrl, coverUrl }) {
    const base = getUploadBase();
    const token = getToken();
    const res = await fetch(`${base}/api/admin/delete-book-pdf`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ fileUrl, coverUrl }),
    });
    
    if (!res.ok) throw new Error('خطا در حذف فایل‌های فیزیکی');
    return await res.json();
  }
};